import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SaveSearchComponent } from './save-search.component';
import { InputModule } from '../forms/input/input.module';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxModule } from '../forms/checkbox/checkbox.module';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { Angulartics2Module } from 'angulartics2';
import { SavedSearchModule } from '../my-remax/saved-searches/saved-search/saved-search.module';

@NgModule({
  imports: [
    CommonModule,
    InputModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    CheckboxModule,
    SharedPipesModule,
    Angulartics2Module,
    SavedSearchModule,
  ],
  declarations: [
    SaveSearchComponent
  ],
  exports: [
    SaveSearchComponent
  ]
})
export class SaveSearchModule { }
